import axios from 'axios';
import { push } from 'connected-react-router';
import { AnyAction } from 'redux';
import { call, put, select } from 'redux-saga/effects';
import {
  chargesMapper,
  formatDateToIsoString,
  formatPrice,
  parserRut,
  paymentMapper,
} from '../helpers/utils';
import { RESET_STATE, showError } from './Commons';

export const SET_EMIT_FORM = 'EMIT_FORM/SET';
export const SUBMIT_EMIT_FORM = 'PROPOSAL/SUBMIT';
export const EMITTING = 'EMITTING';
export const FAIL_EMITTING = 'EMITTING/FAIL';
export const SET_PROPOSAL = 'PROPOSAL/SET';
export const URL_EMIT = '/closure';

export type PaymentMethod = 'CMR' | 'OTHERS' | 'MANDATE';

export interface IPaymentForm {
  paymentMethod: PaymentMethod;
  cmrCard: string;
  webpayCard: string;
  webpayCardMonth: string;
  webpayCardYear: string;
  declarationCard: boolean;
  nameBank: string;
  accountBank: string;
  billingDay: number;
}

export interface IEmitForm {
  address: string;
  addressNumber: number;
  birthdate: string;
  charges: string;
  cmrCard?: string;
  commune: string;
  declarationCard?: boolean;
  dpsDeclaration: string;
  email: string;
  gender: string;
  maternal: string;
  name: string;
  paternal: string;
  paymentMethod: PaymentMethod;
  phone: string;
  province: string;
  region: string;
  documentId: string;
  webpayCard?: string;
  webpayCardMonth?: string;
  webpayCardYear?: string;
  nameBank?: string;
  accountBank?: string;
  billingDay?: number;
}

export interface IProposal {
  errorMessage: string;
  number: number;
}

export const submitEmitForm = (payload: IEmitForm) => ({
  payload,
  type: SUBMIT_EMIT_FORM,
});

export const emitting = () => ({
  type: EMITTING,
});

export const failEmitting = () => ({
  type: FAIL_EMITTING,
});

export const setEmitForm = (payload: IEmitForm) => ({
  payload,
  type: SET_EMIT_FORM,
});

export const setProposal = (payload: IProposal) => ({
  payload,
  type: SET_PROPOSAL,
});

const initialState = {
  data: {
    accountBank: '',
    address: '',
    addressNumber: 0,
    billingDay: 0,
    birthdate: '',
    cmrCard: '',
    commune: '',
    declarationCard: true,
    documentId: '',
    dpsDeclaration: '',
    email: '',
    gender: '',
    maternal: '',
    name: '',
    nameBank: '',
    paternal: '',
    paymentMethod: 'OTHERS',
    phone: '',
    province: '',
    region: '',
    webpayCard: '',
    webpayCardMonth: '',
    webpayCardYear: '',
  },
  emitting: false,
  proposal: {
    mandateId: '',
    number: 0,
  },
};

export default function proposal(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_EMIT_FORM:
      return {
        ...state,
        data: action.payload,
      };
    case EMITTING:
      return {
        ...state,
        emitting: true,
      };
    case FAIL_EMITTING:
      return {
        ...state,
        emitting: false,
      };
    case SET_PROPOSAL:
      return {
        ...state,
        emitting: false,
        proposal: action.payload,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function* doEmit({ payload }: AnyAction) {
  try {
    yield put(emitting());
    yield put(setEmitForm(payload));

    const {
      Quote: {
        quote: { id: quoteId, consecutive, branch, control },
        planSelected: {
          plan_id,
          planName,
          premium_annual,
          premium_monthly,
          premium_monthly_CLP,
          companyId,
          companyName,
        },
        uuid,
        hashClientId,
      },
    } = yield select();

    const {
      address,
      addressNumber,
      birthdate,
      commune,
      documentId,
      email,
      gender,
      maternal,
      name,
      paternal,
      phone,
      province,
      region,
    } = payload;
    const formattedBirthdate = formatDateToIsoString(birthdate, 'DD-MM-YYYY');
    const emissionData = {
      control,
      executive: {
        channel: 'INTERNET',
        code: '33285',
      },
      payload: {
        insured: {
          address,
          addressNumber,
          birthdate: formattedBirthdate,
          commune,
          documentId: parserRut(documentId),
          email,
          gender,
          maternal,
          name,
          paternal,
          phone: `+56${phone}`,
          province,
          region,
        },
        insuredInterests: chargesMapper(payload),
        payment: paymentMapper(payload),
      },
      product: {
        company: {
          id: companyId,
          name: companyName,
        },
        premiums: {
          annual: premium_annual,
          local: formatPrice(premium_monthly_CLP),
          monthly: premium_monthly,
        },
        properties: {
          id: plan_id,
          name: planName,
        },
      },
      quote: {
        branch,
        consecutive,
        quoteId,
      },
    };

    const { data } = yield call(axios.post, URL_EMIT, emissionData, {
      headers: { transactionId: uuid, hashClientId },
    });

    yield put(setProposal(data));
    yield put(push('/success'));
  } catch (error) {
    yield put(failEmitting());
    yield put(showError());
  }
}
